import './styles.css'
import fail from '../../images/fail.png'

export default function Error() {
  return (
    <div className="homeDesign flex_design">
        <div className='fail'>
            <img src={fail} alt=""/>
        </div>
      <p className="txt_style">أنتهت الأرقام لهذا اليوم</p>
    </div>
  )
}
